export const stringToMoneyMask = (value) => {
  return Number((value * 100).toFixed(2));
};
